module.exports = __webpack_public_path__ + "img/ribbons.61a4819d.svg";